__turbopack_context__.v({
  "link": "OnlineLocation-module-scss-module__hmdy0a__link",
  "onlineLinkIcon": "OnlineLocation-module-scss-module__hmdy0a__onlineLinkIcon",
  "onlineLocation": "OnlineLocation-module-scss-module__hmdy0a__onlineLocation",
  "text": "OnlineLocation-module-scss-module__hmdy0a__text",
});
